var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section",class:{'padding-0-mobile': _vm.$route.meta.mobile}},[_c('navbar'),_c('div',{staticClass:"container",class:{ 'is-max-desktop': _vm.$route.meta.mobile }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }